import {createRoot} from 'react-dom/client'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
import './_metronic/assets/sass/style.scss'
import './app/components/TableStandard.css'
import {AuthProvider, setupAxios} from './app/modules/auth'
import {AppRoutes} from './app/routing/AppRoutes'
import RoleState from './app/context/RoleState'
setupAxios()

// Suppress benign Chrome ResizeObserver loop errors triggered during fast scrolling/resizing
// Testing Commit
if (typeof window !== 'undefined') {
  const handler = (e: any) => {
    const msg = e?.message || e?.reason?.message || String(e?.reason || '')
    if (msg && (msg.includes('ResizeObserver loop completed') || msg.includes('ResizeObserver loop limit exceeded'))) {
      e.preventDefault?.()
      e.stopImmediatePropagation?.()
      return false
    }
  }
  window.addEventListener('error', handler)
  window.addEventListener('unhandledrejection', handler)
}

const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <AuthProvider>
      <RoleState>
      <AppRoutes />
      </RoleState>
    </AuthProvider>
    // {/* <ReactQueryDevtools initialIsOpen={false} /> */}
  )
}
